<template>
  <div
    v-if="hasQualityLevels"

    class="quality-control"
    :class="popupVisible ? 'active' : ''"
    @mouseleave="popupVisible = false"
  >
    <VsButton
      class="p-0"
      :tracker="getAnalyticPayload(e => e.player['control-bar'].click.quality)"
      icon="md:hd"
      @click.native="popupVisible = !popupVisible"
    />

    <div
      v-if="popupVisible"
      class="quality-control__window"
    >
      <div
        v-for="(level, index) in processedQualityLevels"
        :key="level.labelKey"
        class="quality-control__window__item"
        :class="index === currentQuality ? 'active' : ''"
        @click="$_changeLevel({ level, index })"
      >
        {{ level.label }}
      </div>
    </div>
  </div>
</template>

<script>
import VsButton from '@/scripts/Components/Molecules/VsButton';
import { getAnalyticPayload } from '@/scripts/libs/analytic';

export default {
  components: {
    VsButton,
  },
  props: {
    currentQuality: {
      type: Number,
      required: true,
    },
    visualQuality: {
      type: Object,
      default: undefined,
    },
    qualityLevels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      popupVisible: false,
    };
  },

  computed: {
    hasQualityLevels() {
      return this.qualityLevels && (this.qualityLevels.length > 0);
    },

    processedQualityLevels() {
      if (!this.qualityLevels) return [];

      return this.qualityLevels.map(({ bitrate, height, label, width }) => {
        const newLabel = (height && width)
          ? `${Math.min(height, width)}p`
          : label
          ;

        const labelKey = (height && width)
          ? `${Math.min(height, width)}p-${bitrate}`
          : label
          ;

        return ({
          height,
          width,
          bitrate,
          label: newLabel,
          labelKey: labelKey,
        });
      });
    },
  },

  methods: {
    $_changeLevel({ level, index }) {
      this.analytic.send(
        getAnalyticPayload(
          e => e.player['change-quality'],
          level.label,
        ),
      );
      this.$emit('levelChanged', index);
    },

    getAnalyticPayload,
  },
};
</script>

<style lang="scss" scoped>
$active-bg-color: rgba(black, 0.95);

.quality-control {
  position: relative;
  z-index: 1;
  .vs-icon {
    transform: rotate(0deg);
    transition: transform 0.25s;
  }
}
.quality-control.active {
  background-color: $active-bg-color;

  .vs-icon {
    color: white;
    transform: rotate(90deg);
  }
  .quality-control__window {
    background-color: $active-bg-color;
  }
}

.quality-control__window {
  position: absolute;
  bottom: 100%;
  right: 0;
  padding: 8px 0;
  width: auto;
  height: auto;
  max-height: calc(56vw - 20px); // prevent small screen from not able to select quality
  overflow: auto;
}

.quality-control__window__item {
  padding: 8px 36px;
  cursor: pointer;
}
.quality-control__window__item:hover {
  background: rgba(white, 0.1);
}
.quality-control__window__item.active {
  background: rgba(white, 0.2);
}
</style>
